<template>
  <v-app>
    <toolbar-nav v-if="needToolbar" />
    <loading/>
    <v-content id="main-app">
      <router-view/>
    </v-content>
    <snackbar/>
    <bottom-nav />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ToolbarNav from './components/navs/ToolbarNav.vue';
import BottomNav from './components/navs/BottomNav.vue';
import Loading from './components/feedbacks/Loading.vue';
import Snackbar from './components/feedbacks/Snackbar.vue';

export default {
  name: 'App',
  components: {
    ToolbarNav,
    BottomNav,
    Loading,
    Snackbar,
  },
  computed: {
    ...mapGetters([
      'hasSession',
      'currentPrincipal',
      'needToolbar',
    ]),
  },
  watch: {
    currentPrincipal(value) {
      if (!value && this.$route.meta.requiresAuth) {
        this.goTo('login');
      }

      if (value) {
        this.fetchHasPendingEvaluations();
      }
    },
  },
  mounted() {
    if (!this.currentPrincipal && this.hasSession) {
      this.fetchPrincipal();
    }
  },
  methods: {
    ...mapActions(['fetchPrincipal', 'fetchHasPendingEvaluations']),
    goTo(name) {
      this.$router.push({ name });
    },
  },
};
</script>
